(function () {
  'use strict';

  var root = document.getElementById('lf-root');
  if (!root) return;

  var CATALOG = JSON.parse(document.getElementById('lf-catalog').textContent);
  var QUOTATION_CONFIG = JSON.parse(document.getElementById('lf-quotation-config').textContent);
  var WHATSAPP_NUMBER = root.dataset.whatsapp || '';
  var CURRENCY = root.dataset.currency || '₹';

  var PICKUP_ENABLED = root.dataset.pickupEnabled === 'true';
  var PICKUP_MESSAGE = root.dataset.pickupMessage || '';
  var DELIVERY_MESSAGE = root.dataset.deliveryMessage || '';

  var EMI_ENABLED = root.dataset.emiEnabled === 'true';
  var EMI_NO_COST_TENURES = (root.dataset.emiNoCostTenures || '')
    .split(',').map(function (s) { return parseInt(s.trim(), 10); }).filter(Boolean);
  var EMI_INTEREST_TENURES = (root.dataset.emiInterestTenures || '')
    .split(',').map(function (s) { return parseInt(s.trim(), 10); }).filter(Boolean);
  var EMI_ANNUAL_RATE = parseFloat(root.dataset.emiInterestRate) || 0;

  var form = document.getElementById('lf-form');
  var useField = document.getElementById('lf-use');
  var brandSelect = document.getElementById('lf-brand');
  var intro = document.getElementById('lf-intro');
  var results = document.getElementById('lf-results');

  // -------------------- weighting profiles --------------------
  var WEIGHTS = {
    gaming:   { gpu: .35, cpu: .25, ram: .15, refresh: .15, storage: .10, battery: 0,   portability: 0   },
    editing:  { gpu: .15, cpu: .30, ram: .20, refresh: .05, storage: .20, battery: .05, portability: .05 },
    business: { gpu: .05, cpu: .25, ram: .15, refresh: 0,   storage: .10, battery: .20, portability: .25 },
    student:  { gpu: 0,   cpu: .15, ram: .10, refresh: 0,   storage: .10, battery: .30, portability: .35 }
  };

  function money(n) { return CURRENCY + Math.round(n).toLocaleString('en-IN'); }
  function norm(s) { return (s || '').toString().trim().toLowerCase(); }

  // Handles metafields entered either as a bare number ("16") or with the
  // unit already typed in ("16GB") — appends the unit only when the raw
  // value doesn't already contain letters, so it never doubles up.
  function formatWithUnit(raw, unit) {
    if (raw === '' || raw === null || raw === undefined) return null;
    var s = String(raw).trim();
    if (!s) return null;
    return /[a-zA-Z]/.test(s) ? s : s + ' ' + unit;
  }
  function escapeHtml(s) {
    return (s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // -------------------- metafield-only scoring inputs --------------------
  // No text-parsing fallback: a blank cpu_score/gpu_score metafield means
  // "not yet rated," handled explicitly wherever it's used below, never
  // guessed from the title.
  function scoreOrNull(v) {
    if (v === '' || v === null || v === undefined) return null;
    var n = parseFloat(v);
    return isNaN(n) ? null : n;
  }
  function effectiveCpuScore(p) { return scoreOrNull(p.cpu_score); }
  function effectiveGpuScore(p) { return scoreOrNull(p.gpu_score); }
  function num(v, fallback) {
    var n = parseFloat(v);
    return isNaN(n) ? fallback : n;
  }

  // -------------------- filtering --------------------
  function screenBand(inches) {
    var n = parseFloat(inches);
    if (isNaN(n)) return null;
    if (n < 14.5) return 'small';
    if (n < 16.5) return 'mid';
    return 'large';
  }

  function filterCatalog(params) {
    var pool = CATALOG.laptop.filter(function (p) { return p.available !== false; });
    if (!pool.length) pool = CATALOG.laptop;
    var relaxed = [];

    // Explicit spec choices are hard requirements — a 15.6" laptop can
    // never become 17", so these apply first. Budget is comparatively
    // flexible (and already flagged per-card as over/under budget), so it
    // applies last and is the one most readily relaxed if it conflicts
    // with a genuine spec requirement.
    if (params.brand) {
      var byBrand = pool.filter(function (p) { return norm(p.vendor) === norm(params.brand); });
      if (byBrand.length) pool = byBrand;
      else relaxed.push('brand');
    }
    if (params.screenSize) {
      var byScreen = pool.filter(function (p) { return screenBand(p.screen_inch) === params.screenSize; });
      if (byScreen.length) pool = byScreen;
      else relaxed.push('screen size');
    }
    if (params.minRam) {
      var byRam = pool.filter(function (p) { return num(p.ram_gb, 0) >= params.minRam; });
      if (byRam.length) pool = byRam;
      else relaxed.push('minimum RAM');
    }
    if (params.minStorage) {
      var byStorage = pool.filter(function (p) { return num(p.storage_gb, 0) >= params.minStorage; });
      if (byStorage.length) pool = byStorage;
      else relaxed.push('minimum storage');
    }
    if (params.budget) {
      var ceiling = params.budget * 1.5;
      var byBudget = pool.filter(function (p) { return p.price <= ceiling; });
      if (byBudget.length) {
        pool = byBudget;
      } else {
        // Nothing fits even the relaxed ceiling. Fall back to the cheapest
        // options within the pool (which already respects screen/brand/RAM/
        // storage), so "closest available" means closest in price — not
        // whatever scores highest on specs regardless of cost.
        pool = pool.slice().sort(function (a, b) { return a.price - b.price; }).slice(0, 10);
        relaxed.push('budget');
      }
    }

    return { pool: pool, relaxed: relaxed };
  }

  // -------------------- scoring --------------------
  function minMax(values) {
    var min = Math.min.apply(null, values), max = Math.max.apply(null, values);
    return { min: min, max: max };
  }
  function normalize(v, range) {
    if (range.max === range.min) return 0.5;
    return (v - range.min) / (range.max - range.min);
  }

  function rankLaptops(pool, params) {
    if (!pool.length) return [];
    var weights = WEIGHTS[params.primaryUse] || WEIGHTS.student;

    var enriched = pool.map(function (p) {
      return {
        product: p,
        cpu: effectiveCpuScore(p),
        gpu: effectiveGpuScore(p),
        ram: scoreOrNull(p.ram_gb),
        storage: scoreOrNull(p.storage_gb),
        refresh: scoreOrNull(p.refresh_hz),
        battery: scoreOrNull(p.battery_wh),
        weight: scoreOrNull(p.weight_kg)
      };
    });

    // build each dimension's range from only the laptops that actually have
    // that metafield set — a blank field never fabricates a number, it just
    // doesn't participate in setting the scale, and scores as neutral (0.5)
    function rangeOf(key) {
      var vals = enriched.map(function (e) { return e[key]; }).filter(function (v) { return v !== null; });
      return vals.length ? minMax(vals) : null;
    }
    var ranges = {
      cpu: rangeOf('cpu'), gpu: rangeOf('gpu'), ram: rangeOf('ram'),
      storage: rangeOf('storage'), refresh: rangeOf('refresh'),
      battery: rangeOf('battery'), weight: rangeOf('weight')
    };

    function scoreDim(value, range) {
      return (value !== null && range) ? normalize(value, range) : 0.5;
    }

    enriched.forEach(function (e) {
      var portability = e.weight !== null && ranges.weight ? (1 - scoreDim(e.weight, ranges.weight)) : 0.5;
      e.score =
        weights.cpu * scoreDim(e.cpu, ranges.cpu) +
        weights.gpu * scoreDim(e.gpu, ranges.gpu) +
        weights.ram * scoreDim(e.ram, ranges.ram) +
        weights.storage * scoreDim(e.storage, ranges.storage) +
        weights.refresh * scoreDim(e.refresh, ranges.refresh) +
        weights.battery * scoreDim(e.battery, ranges.battery) +
        weights.portability * portability;

      // budget proximity — real signal in both directions, not just a
      // one-sided over-budget penalty, so price meaningfully differentiates
      // laptops that are otherwise tied on specs (e.g. not yet rated)
      var priceDelta = (e.product.price - params.budget) / params.budget;
      if (priceDelta > 0) {
        e.score -= Math.min(priceDelta, 1) * 0.25;
      } else {
        e.score += (1 - Math.min(Math.abs(priceDelta), 1)) * 0.08;
      }
    });

    enriched.sort(function (a, b) { return b.score - a.score; });
    return enriched;
  }

  // Near-tied laptops (common while most of the catalog is still unrated)
  // otherwise always resolve to the same order every time. Shuffle within
  // each tie band before taking the top N, so results have real variety
  // without ever letting a genuinely worse match outrank a better one.
  function shuffleTiesAndTake(sorted, epsilon, count) {
    var result = sorted.slice();
    var i = 0;
    while (i < result.length) {
      var j = i;
      while (j + 1 < result.length && Math.abs(result[j + 1].score - result[i].score) <= epsilon) j++;
      for (var k = j; k > i; k--) {
        var r = i + Math.floor(Math.random() * (k - i + 1));
        var tmp = result[k]; result[k] = result[r]; result[r] = tmp;
      }
      i = j + 1;
    }
    return result.slice(0, count);
  }

  function reasonFor(e, primaryUse) {
    var bits = [];
    if (primaryUse === 'gaming') {
      bits.push(e.gpu === null ? 'graphics not yet rated' : (e.gpu >= 7 ? 'strong' : e.gpu >= 4 ? 'capable' : 'entry-level') + ' dedicated graphics');
      if (e.refresh !== null && e.refresh >= 120) bits.push(e.refresh + 'Hz display');
    } else if (primaryUse === 'editing') {
      bits.push(e.cpu === null ? 'CPU not yet rated' : 'CPU suited to sustained workloads');
      if (e.ram !== null) bits.push(e.ram + 'GB RAM');
    } else if (primaryUse === 'business') {
      if (e.battery !== null) bits.push('longer battery life');
      if (e.weight !== null) bits.push('good portability');
      if (!bits.length) bits.push('best match on rated specs so far');
    } else {
      if (e.weight !== null) bits.push(e.weight + 'kg, easy to carry');
      bits.push('fits your budget');
    }
    return 'Recommended for ' + bits.join(' + ') + '.';
  }

  // -------------------- EMI (same approach as PC Build Finder) --------------------
  function noCostEmi(amount, months) { return amount / months; }
  function interestEmi(amount, months, annualRatePercent) {
    var r = (annualRatePercent / 100) / 12;
    if (r === 0) return amount / months;
    var factor = Math.pow(1 + r, months);
    return amount * r * factor / (factor - 1);
  }
  function renderEmi(amount) {
    if (!EMI_ENABLED || amount <= 0) return '';
    var rows = [];
    EMI_NO_COST_TENURES.forEach(function (m) { rows.push({ months: m, monthly: noCostEmi(amount, m), noCost: true }); });
    EMI_INTEREST_TENURES.forEach(function (m) {
      var monthly = interestEmi(amount, m, EMI_ANNUAL_RATE);
      rows.push({ months: m, monthly: monthly, noCost: false, extraInterest: (monthly * m) - amount });
    });
    if (!rows.length) return '';
    rows.sort(function (a, b) { return a.months - b.months; });
    var body = rows.map(function (row) {
      var tag = row.noCost
        ? '<span class="lf-emi-tag">No cost</span>'
        : '<span class="lf-emi-tag interest">+' + money(row.extraInterest) + ' interest</span>';
      return '<tr><td>' + row.months + ' months</td><td>' + money(row.monthly) + '/mo</td><td>' + tag + '</td></tr>';
    }).join('');
    return (
      '<details class="lf-emi"><summary>EMI options from ' + money(rows[0].monthly) + '/mo</summary>' +
      '<table class="lf-emi-table"><thead><tr><th>Tenure</th><th>Monthly</th><th></th></tr></thead><tbody>' + body + '</tbody></table>' +
      '<p class="lf-emi-note">Indicative figures — final EMI terms depend on your bank/card issuer.</p></details>'
    );
  }
  function renderFulfilment() {
    if (!PICKUP_ENABLED) return '';
    var parts = [];
    if (PICKUP_MESSAGE) parts.push('<span>🏬 ' + escapeHtml(PICKUP_MESSAGE) + '</span>');
    if (DELIVERY_MESSAGE) parts.push('<span>🚚 ' + escapeHtml(DELIVERY_MESSAGE) + '</span>');
    return parts.length ? '<div class="lf-fulfilment">' + parts.join('') + '</div>' : '';
  }

  // -------------------- rendering --------------------
  var STATE = { ranked: [], params: null, selections: {} }; // selections[productId] = {variantId, accessoryIds:[]}

  function renderCard(e, index, params) {
    var p = e.product;
    var sel = STATE.selections[p.id];
    var variant = p.variants.find(function (v) { return v.id === sel.variantId; }) || p.variants[0];
    var price = variant ? variant.price : p.price;

    var accessoriesTotal = 0;
    var accessoryPool = params.includeAccessories ? CATALOG.mouse.concat(CATALOG.accessory) : [];
    var accessoryRows = accessoryPool.map(function (a) {
      var checked = sel.accessoryIds.indexOf(a.id) !== -1;
      if (checked) accessoriesTotal += a.price;
      return (
        '<label class="lf-accessory-item">' +
          '<input type="checkbox" data-accessory-id="' + a.id + '"' + (checked ? ' checked' : '') + '>' +
          (a.image ? '<img src="' + a.image + '" alt="">' : '') +
          '<span class="name">' + escapeHtml(a.title) + '</span>' +
          '<span class="price">' + money(a.price) + '</span>' +
        '</label>'
      );
    }).join('');

    var total = price + accessoriesTotal;
    var priceDelta = total - params.budget;
    var priceNote = priceDelta > 0
      ? '<span class="note warn">' + money(priceDelta) + ' over budget</span>'
      : '<span class="note ok">' + money(-priceDelta) + ' under budget</span>';

    var variantOptions = p.variants.map(function (v) {
      var selAttr = v.id === variant.id ? ' selected' : '';
      return '<option value="' + v.id + '"' + selAttr + '>' + escapeHtml(v.title) + ' — ' + money(v.price) + '</option>';
    }).join('');

    var specs = [
      ['CPU', p.cpu_model ? p.cpu_model : (e.cpu === null ? 'Not yet rated' : 'See listing')],
      ['RAM', formatWithUnit(p.ram_gb, 'GB') || '—'],
      ['Storage', formatWithUnit(p.storage_gb, 'GB') || '—'],
      ['Graphics', p.gpu_model ? p.gpu_model : (e.gpu === null ? 'Not yet rated' : (e.gpu >= 1 ? 'Dedicated' : 'Integrated'))],
      ['Display', p.refresh_hz && parseFloat(p.refresh_hz) > 60 ? formatWithUnit(p.refresh_hz, 'Hz') : (p.refresh_hz ? 'Standard' : '—')]
    ].map(function (row) {
      return '<div><span class="k">' + row[0] + '</span><span class="v">' + escapeHtml(String(row[1])) + '</span></div>';
    }).join('');

    return (
      '<div class="lf-card" data-product-id="' + p.id + '">' +
        '<div class="lf-card-head">' +
          (p.image ? '<img src="' + p.image + '" alt="">' : '') +
          '<div class="lf-card-head-main">' +
            '<h4><span class="lf-card-rank">' + (index + 1) + '</span>' + escapeHtml(p.title) + '</h4>' +
            '<p class="lf-card-vendor">' + escapeHtml(p.vendor) + '</p>' +
            '<p class="lf-card-reason">' + reasonFor(e, params.primaryUse) + '</p>' +
          '</div>' +
          '<div class="lf-card-price"><span class="amount">' + money(total) + '</span>' + priceNote + '</div>' +
        '</div>' +
        '<div class="lf-specs">' + specs + '</div>' +
        (p.variants.length > 1
          ? '<div class="lf-variant-row"><label>Configuration</label><select class="lf-variant-select" data-product-id="' + p.id + '">' + variantOptions + '</select></div>'
          : '') +
        renderFulfilment() +
        (params.includeAccessories && accessoryPool.length
          ? '<div class="lf-accessories"><p class="lf-accessories-title">Add accessories</p>' + accessoryRows + '</div>'
          : '') +
        renderEmi(total) +
        '<div class="lf-actions">' +
          '<button type="button" class="lf-btn lf-btn-whatsapp" data-action="whatsapp">Send specs to Laptop Expert</button>' +
          '<button type="button" class="lf-btn lf-btn-buy" data-action="buy">Buy this laptop</button>' +
          '<button type="button" class="lf-btn lf-btn-whatsapp" data-action="pdf">Download PDF quotation</button>' +
        '</div>' +
      '</div>'
    );
  }

  function renderAll() {
    var top = STATE.top || [];
    var notice = (STATE.relaxed && STATE.relaxed.length)
      ? '<div class="lf-relaxed-notice">Couldn\'t find laptops matching: <strong>' + STATE.relaxed.join(', ') +
        '</strong> — showing the closest available options instead.</div>'
      : '';
    results.innerHTML = notice + (top.map(function (e, i) { return renderCard(e, i, STATE.params); }).join('')
      || '<div class="lf-empty">No laptops matched — try relaxing a filter or raising the budget.</div>');
    results.hidden = false;
    intro.hidden = true;
  }

  // -------------------- events --------------------
  function uniqueVendors(list) {
    var seen = {}, out = [];
    list.forEach(function (p) {
      var v = (p.vendor || '').trim();
      if (v && !seen[v]) { seen[v] = true; out.push(v); }
    });
    return out.sort();
  }
  uniqueVendors(CATALOG.laptop).forEach(function (v) {
    var o = document.createElement('option'); o.value = v; o.textContent = v; brandSelect.appendChild(o);
  });

  function runSearch(e) {
    if (e && e.preventDefault) e.preventDefault();
    var fd = new FormData(form);
    var params = {
      budget: parseFloat(fd.get('budget')) || 0,
      primaryUse: fd.get('primary_use'),
      minRam: parseInt(fd.get('min_ram'), 10) || 0,
      minStorage: parseInt(fd.get('min_storage'), 10) || 0,
      screenSize: fd.get('screen_size') || '',
      brand: fd.get('brand') || '',
      includeAccessories: fd.get('include_accessories') === 'on'
    };
    if (!params.budget || params.budget <= 0) return;

    var filtered = filterCatalog(params);
    var pool = filtered.pool;
    var ranked = rankLaptops(pool, params);
    var top = shuffleTiesAndTake(ranked, 0.02, 3);

    STATE.ranked = ranked;
    STATE.relaxed = filtered.relaxed;
    STATE.top = top;
    STATE.params = params;
    STATE.selections = {};
    top.forEach(function (e) {
      STATE.selections[e.product.id] = { variantId: e.product.variants[0] ? e.product.variants[0].id : null, accessoryIds: [] };
    });

    renderAll();
    results.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Bound to the button's click directly (the button is type="button", not
  // type="submit") so this never depends on the form's native submit event
  // — a page with other apps/scripts that intercept form submissions can't
  // interfere with a plain button click. The form's submit event is still
  // handled too, purely as a fallback for pressing Enter in a field.
  var submitBtn = document.getElementById('lf-submit-btn');
  if (submitBtn) submitBtn.addEventListener('click', runSearch);
  form.addEventListener('submit', runSearch);

  results.addEventListener('change', function (e) {
    var variantSelect = e.target.closest('.lf-variant-select');
    if (variantSelect) {
      var pid = parseInt(variantSelect.dataset.productId, 10);
      STATE.selections[pid].variantId = parseInt(variantSelect.value, 10);
      renderAll();
      return;
    }
    var accCheckbox = e.target.closest('[data-accessory-id]');
    if (accCheckbox) {
      var card = e.target.closest('.lf-card');
      var productId = parseInt(card.dataset.productId, 10);
      var accId = parseInt(accCheckbox.dataset.accessoryId, 10);
      var sel = STATE.selections[productId];
      var idx = sel.accessoryIds.indexOf(accId);
      if (accCheckbox.checked && idx === -1) sel.accessoryIds.push(accId);
      if (!accCheckbox.checked && idx !== -1) sel.accessoryIds.splice(idx, 1);
      renderAll();
    }
  });

  results.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var card = e.target.closest('.lf-card');
    var productId = parseInt(card.dataset.productId, 10);
    var entry = STATE.ranked.find(function (r) { return r.product.id === productId; });
    if (!entry) return;

    if (btn.dataset.action === 'whatsapp') sendToWhatsApp(entry);
    if (btn.dataset.action === 'buy') buyLaptop(entry, btn);
    if (btn.dataset.action === 'pdf') downloadQuotation(entry, btn);
  });

  function downloadQuotation(entry, btn) {
    if (!window.VPQuotation) {
      showToast('PDF generator failed to load — please refresh and try again.');
      return;
    }
    var p = entry.product;
    var sel = STATE.selections[p.id];
    var variant = p.variants.find(function (v) { return v.id === sel.variantId; }) || p.variants[0];
    var configLabel = realVariantLabel(p, variant);
    var items = [{ label: 'Laptop', name: p.title + (configLabel ? ' — ' + configLabel : ''), price: variant ? variant.price : p.price }];
    var subtotal = variant ? variant.price : p.price;
    selectedAccessories(p.id).forEach(function (a) {
      items.push({ label: 'Accessory', name: a.title, price: a.price });
      subtotal += a.price;
    });
    var cfg = Object.assign({}, QUOTATION_CONFIG, {
      currencySymbol: CURRENCY,
      emi: { noCostTenures: EMI_NO_COST_TENURES, interestTenures: EMI_INTEREST_TENURES, annualRate: EMI_ANNUAL_RATE }
    });
    var order = {
      title: p.title,
      prefix: 'LPF',
      heroImage: p.image || '',
      items: items,
      subtotal: subtotal
    };
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Preparing PDF…';
    window.VPQuotation.generate(cfg, order)
      .catch(function () { showToast('Could not generate the PDF — please try again.'); })
      .then(function () { btn.disabled = false; btn.textContent = original; });
  }

  function selectedAccessories(productId) {
    var sel = STATE.selections[productId];
    var pool = CATALOG.mouse.concat(CATALOG.accessory);
    return pool.filter(function (a) { return sel.accessoryIds.indexOf(a.id) !== -1; });
  }

  // Shopify names a product's only variant "Default Title" when it has no
  // real options (RAM/storage/colour choices) — that's meant to be
  // invisible to customers, never something to display.
  function realVariantLabel(p, variant) {
    if (!variant || p.variants.length <= 1) return null;
    if (norm(variant.title) === 'default title') return null;
    return variant.title;
  }

  function sendToWhatsApp(entry) {
    var p = entry.product;
    var sel = STATE.selections[p.id];
    var variant = p.variants.find(function (v) { return v.id === sel.variantId; }) || p.variants[0];
    var configLabel = realVariantLabel(p, variant);
    var lines = [p.title + ' — requested via Laptop Finder', ''];
    if (configLabel) lines.push('Configuration: ' + configLabel);
    lines.push('Price: ' + money(variant ? variant.price : p.price));
    var accessories = selectedAccessories(p.id);
    if (accessories.length) {
      lines.push('', 'Accessories:');
      accessories.forEach(function (a) { lines.push('- ' + a.title + ' (' + money(a.price) + ')'); });
    }
    var text = encodeURIComponent(lines.join('\n'));
    window.open('https://wa.me/' + WHATSAPP_NUMBER + (WHATSAPP_NUMBER ? '?text=' + text : ''), '_blank');
  }

  function buyLaptop(entry, btn) {
    var p = entry.product;
    var sel = STATE.selections[p.id];
    var items = [];
    if (sel.variantId) items.push({ id: sel.variantId, quantity: 1 });
    selectedAccessories(p.id).forEach(function (a) { if (a.variant_id) items.push({ id: a.variant_id, quantity: 1 }); });
    if (!items.length) return;

    btn.disabled = true;
    btn.textContent = 'Adding to cart…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { if (!res.ok) throw new Error('Cart add failed'); return res.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () {
        showToast('Could not add to cart — please check stock and try again.');
        btn.disabled = false;
        btn.textContent = 'Buy this laptop';
      });
  }

  function showToast(msg) {
    var t = document.createElement('div');
    t.className = 'lf-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 4000);
  }
})();
